import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, Transition as _Transition, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dac6f35e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collapse" }
const _hoisted_2 = { class: "toc-header" }
const _hoisted_3 = { class: "toc-try-this-attached" }
const _hoisted_4 = {
  key: 0,
  class: "control"
}
const _hoisted_5 = ["aria-label"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-medium" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-left" })
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "control"
}
const _hoisted_9 = ["aria-label"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon is-medium" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" })
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "buttons has-addons toc-expand-collapse"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lg fa-plus-square" })
], -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-lg fa-minus-square" })
], -1))
const _hoisted_15 = {
  key: 0,
  class: "menu is-paddingless"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dropdown-footer" }, null, -1))

import { useStore} from 'vuex'
import { ref, computed, onMounted, onBeforeUnmount, watch, nextTick } from "vue"
import { useRoute } from 'vue-router'
import TableOfContentsItem from "@/components/library/content/header/TableOfContentsItem.vue";
import SearchTypeAhead from "@/components/common/search/SearchTypeAhead.vue";
import {useWidgetToc} from "@/components/widgets/composables/useWidgetToc";
import TryThisPill from "@/components/common/TryThisPill.vue";
import TocContentTabs from '@/components/library/content/TocContentTabs.vue'
import TocThreeDContent from '@/components/library/content/TocThreeDContent.vue'
import { getThreeDTocSearchResultKey } from '@/helpers/threeDTocSearch'
const collapsedWidth = 50
const minPanelWidth = 220
const maxPanelWidth = 1200

export default /*#__PURE__*/_defineComponent({
  __name: 'TocNavigation',
  props: {
    enableThreeDContent: { type: Boolean, default: false },
    query: {}
  },
  setup(__props: any) {

const { contentPath,
  useWidgetTocNav, getFlatListIdx } = useWidgetToc()
const store = useStore()
const route = useRoute()

const props = __props

const persistedTocQuery = computed(() => {
  const q = store.state.search?.filters?.tocQuery
  return (typeof q === 'string') ? q : ''
})

const localQuery = ref(props.query || persistedTocQuery.value || '')

const expanded = ref(false)
const isResizing = ref(false)
const panelWidth = ref(350)

const tocStyle = computed(() => {
  const width = collapsedWidth + (expanded.value ? panelWidth.value : 0)
  return {
    flexBasis: `${width}px`,
    maxWidth: `${width}px`
  }
})

let resizeStartX = 0
let resizeStartWidth = 0
let suppressClick = false
const bookSearch = ref(false)
const highlightedInstance = ref(-1)
const forceOpen = ref(0)
const searchResults = ref<any[]>([])
const hasAutoNavigatedInitialResult = ref(false)
const autoSelectedQuery = ref('')
const searchPending = ref(false)
let searchRequestId = 0

const book = computed(() => store.state.content?.toc?.book)
const isWidget = computed(() => store.getters['widgets/isWidget'])
const selectBomItemsFromCallout = (item?: string) => store.dispatch('content/selectBomItemsFromCallout', item)
const searchContentNameLabel = computed(() => {
  const name = book.value?.name || ''
  return name.length > 25 ? name.substring(0, 25) : name
})
const toc = computed(() => store.state.content?.toc?.items)
const threeDModels = computed(() => store.getters['content/threeDModels'] || [])
const threeDSearchResults = computed<any[]>(() => store.getters['content/threeDTocSearchResults'] || [])
const selectedThreeDSearchResultKey = computed(() =>
  store.state.content?.toc?.selectedThreeDSearchResultKey || ''
)
const threeDModelSnapshotsLoaded = computed(() =>
  Boolean(store.state.content?.toc?.isThreeDModelSnapshotsLoaded)
)
const activeContent = computed(() => {
  return props.enableThreeDContent
    ? store.state.content?.toc?.activeContent
    : '2d'
})
const viewerActiveContent = computed(() =>
  store.state.content?.toc?.viewerActiveContent || activeContent.value
)
const isTocOpen = computed(() => store.state.content?.toc?.isTocOpen)
const widgetContentPath = computed(() => contentPath.value )

const countTocItems = (items: any[]): number => {
  return (items || []).reduce((acc, item) => {
    const children = Array.isArray(item?.children) ? item.children : []
    const type = (item?.type == null ? '' : String(item.type)).trim().toLowerCase()
    const isPage = type === 'page'
    return acc + (isPage ? 1 : 0) + countTocItems(children)
  }, 0)
}

const shouldShowFilteredCount = computed(() => Boolean(localQuery.value?.length))
const tocTotalCount = computed(() => countTocItems(toc.value || []) + threeDModels.value.reduce(
  (count: number, model: any) => count + 1 + (model.snapshots?.length || 0),
  0
))
const tocResultCount = computed(() => Number(store.state.content?.toc?.resultCount || 0))
const hasSearchResults = computed(() => tocResultCount.value > 0)
const tocTotalDisplayed = computed(() => {
  if (!tocQuery.value?.length) return tocTotalCount.value
  return tocResultCount.value
})

const storeInitialSearchQuery = computed(() => {
  const filters = store.state.search?.filters
  const tocQuery = filters?.tocQuery

  if (typeof tocQuery === 'string' && tocQuery.length) return tocQuery
  return ''
})

const path = computed(() => {
  return book.value ? `/${book.value.contentType}/${book.value.id}/` : ''
})

const getTOCSearchResults = (payload: any) => store.dispatch('content/tocSearchWithReturn', payload)
const updateTocOpen = (value: boolean) => store.dispatch('content/updateTocOpen', value)
const navigateToContentPath = (payload: any) => store.dispatch('content/navigateToContentPath', payload)

const tocQuery = computed(() => localQuery.value || '')
const hasTocQuery = computed(() => tocQuery.value?.length > 0)
let lastSearchQuery = tocQuery.value.trim()

const selectedFlatListIdx = ref(-1)

const highlightedTocItems = ref<Array<{ itemPath: string, flatListIdx: number }>>([])


const setActiveTocHighlighted = (elements: HTMLCollectionOf<Element>, idx: number) => {
  for (let i = 0; i < elements.length; i++) {
    elements.item(i)?.classList.remove('menu-list-highlighted-active')
  }
  elements.item(idx)?.classList.add('menu-list-highlighted-active')
}

const clearActiveTocHighlighted = () => {
  const active = document.getElementsByClassName('menu-list-highlighted-active')
  while ((active?.length ?? 0) > 0) {
    active.item(0)?.classList.remove('menu-list-highlighted-active')
  }
}

const scrollSelectedIntoView = async (itemPath: string) => {
  if (!expanded.value) return
  await nextTick()

  const panel = document.querySelector('.toc-panel') as HTMLElement | null
  if (!panel) return

  const selector = isWidget.value
    ? `#toc-item-${selectedFlatListIdx.value}`
    : `a[href*="${itemPath}"]`
  const el = panel.querySelector(selector) as HTMLElement | null
  if (!el) return

  el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
}

const nextResult = () => {
  if (!canNavigateResults.value) return

  if (activeContent.value === '3d') {
    selectAdjacentThreeDResult(1)
    return
  }

  const results = highlightedTocItems.value
  if (results.length < 2) return

  const currentIndex = viewerActiveContent.value === '2d'
    ? results.findIndex(r => r.flatListIdx === selectedFlatListIdx.value)
    : -1
  const nextIndex = currentIndex >= 0
    ? (currentIndex + 1) % results.length
    : 0

  const nextItem = results[nextIndex]
  if (nextItem) select(nextItem.itemPath)

  const active = document.activeElement as HTMLElement | null
  active?.blur?.()
}

const previousResult = () => {
  if (!canNavigateResults.value) return

  if (activeContent.value === '3d') {
    selectAdjacentThreeDResult(-1)
    return
  }

  const results = highlightedTocItems.value
  if (results.length < 2) return

  const currentIndex = viewerActiveContent.value === '2d'
    ? results.findIndex(r => r.flatListIdx === selectedFlatListIdx.value)
    : -1
  const prevIndex = currentIndex >= 0
    ? (currentIndex - 1 + results.length) % results.length
    : (results.length - 1)

  const prevItem = results[prevIndex]
  if (prevItem) select(prevItem.itemPath)

  const active = document.activeElement as HTMLElement | null
  active?.blur?.()
}

const setActiveFromItemPath = (itemPath: string) => {
  const highlighted = document.getElementsByClassName('menu-list-highlighted')
  const count = highlighted?.length ?? 0
  if (count <= 0) return

  for (let i = 0; i < count; i++) {
    const el = highlighted.item(i) as HTMLElement | null
    const link = el?.querySelector('a')
    const href = link?.getAttribute('href') || ''
    if (href && href.includes(itemPath)) {
      highlightedInstance.value = i
      setActiveTocHighlighted(highlighted, i)
      return
    }
  }
}

const search = (query: string, bSearch: boolean) => {
  const requestId = ++searchRequestId
  const q = query || ''
  const normalizedQuery = q.trim()
  const queryChanged = normalizedQuery !== lastSearchQuery
  if (autoSelectedQuery.value !== normalizedQuery) autoSelectedQuery.value = ''
  searchPending.value = true
  localQuery.value = q
  if (queryChanged) {
    searchResults.value = []
    highlightedTocItems.value = []
    selectedFlatListIdx.value = -1
    highlightedInstance.value = -1
    clearActiveTocHighlighted()
  }
  if (q) {
    void store.dispatch('search/setTocQuery', q)
  } else {
    void store.dispatch('search/clearTocQuery')
  }
  return Promise.resolve(getTOCSearchResults({ query: q }))
    .then((results: any[]) => {
      if (requestId !== searchRequestId) return
      searchPending.value = false
      searchResults.value = results || []
      highlightedInstance.value = -1
      clearActiveTocHighlighted()

      lastSearchQuery = normalizedQuery
      rebuildHighlightedTocItems(!queryChanged)

      void autoSelectUnifiedResult()

      if (tocResultCount.value > 0) {
        expanded.value = true
        updateTocOpen(true)
        bookSearch.value = bSearch || false
      }
    })
}

const runInitialSearchFromStore = () => {
  if (hasAutoNavigatedInitialResult.value) return
  const q = storeInitialSearchQuery.value
  if (!q) return

  hasAutoNavigatedInitialResult.value = true

  if (!localQuery.value) localQuery.value = q
  void search(q, true)
}

const expand = () => {
  forceOpen.value += 1;
}

const collapse = () => {
  forceOpen.value -= 1;
}

const isHighlighted = (item: any) => {
  const normalizeId = (v: unknown) => (v == null ? '' : String(v))
  const normalizeType = (v: unknown) => (v == null ? '' : String(v).trim().toLowerCase())

  const itemId = normalizeId(item?.id)
  const itemType = normalizeType(item?.type)

  return (searchResults.value || []).some((tocItem: any) => {
    return normalizeId(tocItem?.entityId) === itemId &&
      normalizeType(tocItem?.entityType) === itemType
  })
}

const getItemPath = (item: any) => {
  return path.value + item.type + ':' + item.id
}

const select = async (itemPath: string) => {
  await store.dispatch('content/updateViewerActiveContent', '2d')
  if (tocQuery.value?.length) {
    setActiveFromItemPath(itemPath)
  }
  if (tocQuery.value?.length) {
    const idx = getFlatListIdx(itemPath)
    selectedFlatListIdx.value = idx
  }
  const q = localQuery.value || ''
  if (q && persistedTocQuery.value !== q) {
    await store.dispatch('search/setTocQuery', q)
  }

  if (isWidget.value) {
    await widgetNav(itemPath)
    return
  }

  await navigateToContentPath({
    path: itemPath
  })
}

const widgetNav = async (itemPath: string) => {
  const q = localQuery.value || persistedTocQuery.value || ''
  if (q) {
    await store.dispatch('search/setBomQuery', q)
  }
  await useWidgetTocNav(itemPath)
}

const toggleExpanded = () => {
  expanded.value = !expanded.value
  updateTocOpen(expanded.value)
}

const searchFilteredTocItems = computed(() => {
  const tocItems = toc.value || []
  if (!tocQuery.value?.length) return tocItems
  // If there is an active TOC search query but no results, show no items.
  if (!(searchResults.value || []).length) return []
  const normalizeId = (v: unknown) => (v == null ? '' : String(v))
  const normalizeType = (v: unknown) => (v == null ? '' : String(v).trim().toLowerCase())

  const resultKeys = new Set(
    (searchResults.value || [])
      .filter(r => r?.entityId != null && r?.entityType)
      .map(r => `${normalizeType(r.entityType)}:${normalizeId(r.entityId)}`)
  )

  const filterTree = (items: any[]) => {
    return (items || []).reduce((acc, item) => {
      const key = `${normalizeType(item?.type)}:${normalizeId(item?.id)}`
      const filteredChildren = item?.children ? filterTree(item.children) : undefined
      const keep = resultKeys.has(key) || (filteredChildren && filteredChildren.length > 0)

      if (keep) {
        acc.push({
          ...item,
          ...(filteredChildren ? { children: filteredChildren } : {})
        })
      }
      return acc
    }, [])
  }

  return filterTree(tocItems)
})

const rebuildHighlightedTocItems = (selectCurrent = true) => {
  const results: Array<{ itemPath: string, flatListIdx: number }> = []
  const walk = (items: any[], parentPath: string) => {
    (items || []).forEach((item) => {
      const itemPath = parentPath + item.type + ':' + item.id
      if (isHighlighted(item)) {
        const idx = getFlatListIdx(itemPath)
        results.push({ itemPath, flatListIdx: idx })
      }
      const children = Array.isArray(item?.children) ? item.children : []
      if (children.length) {
        walk(children, itemPath + '/')
      }
    })
  }
  walk(searchFilteredTocItems.value || [], path.value)
  results.sort((a, b) => a.flatListIdx - b.flatListIdx)
  highlightedTocItems.value = results

  if (!selectCurrent) {
    selectedFlatListIdx.value = -1
    return
  }

  const currentPath = isWidget.value ? widgetContentPath.value : route.path
  const current = results.find(r => r.itemPath === currentPath)
  selectedFlatListIdx.value = current ? current.flatListIdx : -1
}

const selectThreeDSearchResult = (searchResult: any) => store.dispatch(
  'content/selectThreeDTocSearchResult',
  { searchResult }
)

const autoSelectUnifiedResult = async () => {
  const query = tocQuery.value.trim()
  if (!query || searchPending.value || !threeDModelSnapshotsLoaded.value) return
  if (autoSelectedQuery.value === query) return

  const unifiedResultCount = highlightedTocItems.value.length + threeDSearchResults.value.length
  if (unifiedResultCount !== 1) return

  autoSelectedQuery.value = query
  if (highlightedTocItems.value.length === 1) {
    const only = highlightedTocItems.value[0]
    if (only?.itemPath && !isWidget.value) {
      await select(only.itemPath)
      await store.dispatch('search/setBomQuery', tocQuery.value)
    }
    return
  }

  await selectThreeDSearchResult(threeDSearchResults.value[0])
}

const selectAdjacentThreeDResult = (offset: number) => {
  const results = threeDSearchResults.value
  if (results.length < 2) return

  const currentIndex = results.findIndex(result =>
    getThreeDTocSearchResultKey(result) === selectedThreeDSearchResultKey.value
  )
  const nextIndex = currentIndex >= 0
    ? (currentIndex + offset + results.length) % results.length
    : (offset > 0 ? 0 : results.length - 1)
  void selectThreeDSearchResult(results[nextIndex])

  const active = document.activeElement as HTMLElement | null
  active?.blur?.()
}

const canNavigateResults = computed(() => !searchPending.value && (
  activeContent.value === '3d'
    ? threeDSearchResults.value.length > 1
    : highlightedTocItems.value.length > 1
))

const clearClick = async () => {
  searchRequestId++
  autoSelectedQuery.value = ''
  lastSearchQuery = ''
  searchPending.value = false
  localQuery.value = ''
  searchResults.value = []
  highlightedTocItems.value = []
  selectedFlatListIdx.value = -1
  highlightedInstance.value = -1
  clearActiveTocHighlighted()

  void store.dispatch('search/clearTocQuery')
  await getTOCSearchResults({query: ''})
}

const onResizeMove = (e: MouseEvent) => {
  if (!isResizing.value) return
  const next = resizeStartWidth + (e.clientX - resizeStartX)
  panelWidth.value = Math.max(minPanelWidth, Math.min(maxPanelWidth, next))
}

const onResizeClickCapture = (e: MouseEvent) => {
  if (!suppressClick) return
  e.preventDefault()
  e.stopPropagation()
}
const onResizeEnd = () => {
  if (!isResizing.value) return
  isResizing.value = false
  window.removeEventListener('mousemove', onResizeMove)
  window.removeEventListener('mouseup', onResizeEnd)

  // Prevent the click that commonly fires after a drag resize from closing the panel.
  suppressClick = true
  window.addEventListener('click', onResizeClickCapture, true)
  window.setTimeout(() => {
    suppressClick = false
    window.removeEventListener('click', onResizeClickCapture, true)
  }, 0)
}
const startResize = (e: MouseEvent) => {
  isResizing.value = true
  resizeStartX = e.clientX
  resizeStartWidth = panelWidth.value
  window.addEventListener('mousemove', onResizeMove)
  window.addEventListener('mouseup', onResizeEnd)
}

watch(() => props.query, (next, oldValue) => {
  const nextValue = next || ''
  // Avoid re-running the search when the prop update is just reflecting
  // a query we already applied locally (prevents duplicate tocSearch calls).
  if (nextValue === oldValue) return
  if (nextValue === localQuery.value) {
    if (nextValue && !(searchResults.value || []).length) {
      search(nextValue, true)
    }
    return
  }
  if (!nextValue && persistedTocQuery.value) {
    localQuery.value = persistedTocQuery.value
    if (!(searchResults.value || []).length) {
      search(localQuery.value, true)
    }
    return
  }
  localQuery.value = nextValue
  if (localQuery.value) {
    search(localQuery.value, true)
  }
})

watch(() => book.value?.id, () => {
  autoSelectedQuery.value = ''
  lastSearchQuery = ''
})

watch(
  () => [
    tocQuery.value,
    searchPending.value,
    threeDModelSnapshotsLoaded.value,
    highlightedTocItems.value.map(result => result.itemPath).join(','),
    threeDSearchResults.value.map(getThreeDTocSearchResultKey).join(',')
  ],
  () => {
    void autoSelectUnifiedResult()
  }
)

watch(persistedTocQuery, (next) => {
  if (!next) return
  if (next === localQuery.value) {
    if (!(searchResults.value || []).length) {
      search(localQuery.value, true)
    }
    return
  }
  localQuery.value = next
  if (!(searchResults.value || []).length) {
    search(localQuery.value, true)
  }
})

watch(isTocOpen, (open, wasOpen) => {
  expanded.value = Boolean(open)
  if (!open || wasOpen) return
  runInitialSearchFromStore()
})

watch(
  () => [route.path, widgetContentPath.value],
  () => {
    if (!hasTocQuery.value) return
    const currentPath = isWidget.value ? widgetContentPath.value : route.path
    const idx = getFlatListIdx(currentPath)
    selectedFlatListIdx.value = idx
  }
)
//watcher ensures that regardless of source (nav buttons, SableOfContentsStepper)
// or desktop or widgets
// a change in the active page gets results in a scroll into view
watch(
  () => [selectedFlatListIdx.value, route.path, widgetContentPath.value, expanded.value],
  async () => {
    const currentPath = isWidget.value ? widgetContentPath.value : route.path
    await scrollSelectedIntoView(currentPath)
  },
  { flush: 'post' }
)

onMounted(() => {
  expanded.value = isTocOpen.value

  if (isWidget.value) {
    const q = persistedTocQuery.value
    if (q && localQuery.value !== q) localQuery.value = q
  }

  if (storeInitialSearchQuery.value) {
    runInitialSearchFromStore()
    return
  }

  // Fallback to the local query (prop/persisted) when store doesn't have one.
  const q = localQuery.value
  if (q) search(q, true)
})

onBeforeUnmount(() => {
  onResizeEnd()
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toc-navigation", {expanded: expanded.value, 'is-resizing': isResizing.value, 'is-widget': isWidget.value}]),
    style: _normalizeStyle(tocStyle.value)
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_Transition, { name: "toc-content" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "toc-panel",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(SearchTypeAhead, {
                  placeholder: _ctx.$t('searchInContent', { contentName: searchContentNameLabel.value }),
                  "is-bom": false,
                  value: localQuery.value,
                  content: book.value,
                  "show-filtered-count": shouldShowFilteredCount.value,
                  "total-count": tocTotalCount.value,
                  "total-displayed": tocTotalDisplayed.value,
                  "clear-on-enter": false,
                  class: "toc-search",
                  onEnter: search,
                  onClearClick: clearClick
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(TryThisPill, {
                        label: _ctx.$t('trySearchingToc'),
                        "local-storage-property": 'trySearchingToc',
                        "tool-tip-width": '15em',
                        "tool-tip-position": 'is-bottom-left'
                      }, null, 8, ["label"])
                    ]),
                    (hasTocQuery.value && canNavigateResults.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_4, [
                          _createElementVNode("button", {
                            class: "button is-primary is-outlined previous-button",
                            "aria-label": _ctx.$t('threeD.previousResult'),
                            onClick: previousResult
                          }, _hoisted_7, 8, _hoisted_5)
                        ]))
                      : _createCommentVNode("", true),
                    (hasTocQuery.value && canNavigateResults.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_8, [
                          _createElementVNode("button", {
                            class: "button is-primary is-outlined next-button",
                            "aria-label": _ctx.$t('threeD.nextResult'),
                            onClick: nextResult
                          }, _hoisted_11, 8, _hoisted_9)
                        ]))
                      : _createCommentVNode("", true)
                  ], undefined, true),
                  _: 1
                }, 8, ["placeholder", "value", "content", "show-filtered-count", "total-count", "total-displayed"]),
                (_ctx.enableThreeDContent)
                  ? (_openBlock(), _createBlock(TocContentTabs, { key: 0 }))
                  : _createCommentVNode("", true),
                (activeContent.value === '2d')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("button", {
                        class: "button expand-button",
                        onClick: expand
                      }, [
                        _hoisted_13,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('expandAll')), 1)
                      ]),
                      _createElementVNode("button", {
                        class: "button collapse-button",
                        onClick: collapse
                      }, [
                        _hoisted_14,
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t('collapseAll')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (activeContent.value === '2d')
                ? (_openBlock(), _createElementBlock("aside", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchFilteredTocItems.value, (item) => {
                      return (_openBlock(), _createElementBlock("ul", {
                        key: item.id,
                        class: _normalizeClass(["menu-list", {'menu-list-highlighted': isHighlighted(item)}])
                      }, [
                        _createVNode(TableOfContentsItem, {
                          item: item,
                          "item-path": getItemPath(item),
                          highlighted: searchResults.value,
                          "force-open": forceOpen.value,
                          "is-widget": isWidget.value,
                          "flat-list-idx": _unref(getFlatListIdx)(getItemPath(item)),
                          "widget-content-path": widgetContentPath.value,
                          onSelect: select,
                          onWidgetNav: widgetNav
                        }, null, 8, ["item", "item-path", "highlighted", "force-open", "is-widget", "flat-list-idx", "widget-content-path"])
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createBlock(TocThreeDContent, { key: 1 })),
              _hoisted_16
            ], 544), [
              [_vShow, expanded.value]
            ])
          ], undefined, true),
          _: 1
        })
      ])
    ]),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "toc-resizer",
          onMousedown: _withModifiers(startResize, ["stop","prevent"]),
          onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
        }, null, 32))
      : _createCommentVNode("", true)
  ], 6))
}
}

})